import { GUEST_FEE_DISCOUNT_BUCKETS } from "./experiment.consts";

export type GuestFeeDiscountBucket =
  (typeof GUEST_FEE_DISCOUNT_BUCKETS)[number];

/**
 * Normalizes the Statsig guest fee experiment parameter into the backend contract.
 */
export const normalizeGuestFeeDiscountBucket = (
  value: unknown,
): GuestFeeDiscountBucket => {
  if (
    typeof value === "string" &&
    GUEST_FEE_DISCOUNT_BUCKETS.includes(value as GuestFeeDiscountBucket)
  ) {
    return value as GuestFeeDiscountBucket;
  }

  return "full";
};
